import { observable } from 'mobx'

import ThemeModes from '../enums/ThemeModes'
import isTestEnvironment from './environment'
import { HSLToHex } from './HSLtoHex'
import { safeGetItem, safeSetItem } from './safeStorage'

const defaultMode = ThemeModes.light

const THEME_MODE_STORAGE_KEY = 'theme-mode'

export default class ThemeMode {
  @observable public static currentMode: ThemeModes

  public static init() {
    // Same boot-path exposure as Localization.init(): called before render,
    // so an unguarded read is a blank page. Falls back to the default mode.
    const theme = safeGetItem(THEME_MODE_STORAGE_KEY) as ThemeModes
    ThemeMode.setMode(theme || defaultMode)
  }

  public static get isDarkMode(): boolean {
    return ThemeMode.currentMode === ThemeModes.dark
  }

  public static toggleMode() {
    ThemeMode.setMode(ThemeMode.isDarkMode ? ThemeModes.light : ThemeModes.dark)
  }

  public static get shouldShowThemeSelector(): boolean {
    return isTestEnvironment()
  }

  // konva objects only accept HEX colors
  public static getHEXColor(colorStrings: string) {
    if (colorStrings?.startsWith('hsla')) {
      const [h, s, l] = colorStrings
        .split(',')
        .map(colorValue => Number(colorValue.replace(/\D/g, '')))

      return HSLToHex({ h, s, l })
    }

    return colorStrings
  }

  public static setMode(mode: ThemeModes) {
    if (
      (mode !== ThemeModes.dark && mode !== ThemeModes.light) ||
      mode === ThemeMode.currentMode
    ) {
      return
    }

    ThemeMode.currentMode = mode
    safeSetItem(THEME_MODE_STORAGE_KEY, mode)
    if (ThemeMode.isDarkMode) {
      document.body.classList.add(ThemeModes.dark)
      document.body.classList.remove(ThemeModes.light)
    } else {
      document.body.classList.add(ThemeModes.light)
      document.body.classList.remove(ThemeModes.dark)
    }
  }
}
